import { recentOrdersStyles } from "@insite/content-library/Widgets/Common/RecentOrders";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(recentOrdersStyles, {
    cardList: {
        gridContainer: {
            offsetProps: {
                style: {
                    marginLeft: 0,
                    marginRight: 0,
                    width: "100%",
                },
            },
        },
    },
});
